import { themeStack } from './library/stack';
import { themeTheWhiteStripes } from './library/theWhiteStripes';

export const themes = [themeStack, themeTheWhiteStripes];
